/** Bulk action bar that appears when multiple tasks are selected on the Today page. */
import { Box, Button, AppBar, Toolbar } from '@mui/material';
import { useTaskMutationsContext } from '@/features/tasks';
import { useT } from '@/i18n/useT';

const BulkActionBar = ({ selectedTaskIds, onClearSelection, user }) => {
  const t = useT();
  const { updateMultipleTasks } = useTaskMutationsContext();

  const handleMoveToToday = async () => {
    if (!user || selectedTaskIds.length === 0) return;
    const today = new Date().toISOString().split('T')[0];
    try {
      await updateMultipleTasks(selectedTaskIds, { date: today }, user.uid);
      onClearSelection();
    } catch (error) {
      console.error('[BulkActionBar] Failed to move tasks to today:', error);
    }
  };

  const handleClearDates = async () => {
    if (!user || selectedTaskIds.length === 0) return;
    try {
      await updateMultipleTasks(selectedTaskIds, { date: null }, user.uid);
      onClearSelection();
    } catch (error) {
      console.error('[BulkActionBar] Failed to clear dates:', error);
    }
  };

  const handleCompleteAll = async () => {
    if (!user || selectedTaskIds.length === 0) return;
    try {
      await updateMultipleTasks(selectedTaskIds, { completed: true }, user.uid);
      onClearSelection();
    } catch (error) {
      console.error('[BulkActionBar] Failed to complete tasks:', error);
    }
  };

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={1}
      sx={{ top: 'auto', bottom: 0 }}
    >
      <Toolbar
        variant="dense"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
          {selectedTaskIds.length} {t('bulkactionbar.selected', 'selected')}
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button size="small" onClick={handleMoveToToday}>
            {t('bulkactionbar.moveToToday', 'Move to Today')}
          </Button>
          <Button size="small" onClick={handleCompleteAll}>
            {t('bulkactionbar.completeAll', 'Complete All')}
          </Button>
          <Button size="small" onClick={handleClearDates}>
            {t('bulkactionbar.clearDates', 'Clear Dates')}
          </Button>
          <Button size="small" onClick={onClearSelection}>
            {t('bulkactionbar.cancel', 'Cancel')}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default BulkActionBar;
